import InvoicesView from './InvoicesView';

export default InvoicesView;
